export default __webpack_public_path__ + "static/media/tooltip.6c66bc13.svg";